import instance from 'api';
import { IRealEstate } from './interfaces';

export const getRealEstates = (
  data: {
    onlyFromMatrix?: boolean;
    onlyWithKeytransferDate?: boolean;
  } = { onlyFromMatrix: true, onlyWithKeytransferDate: true },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstates', data)
    .then((response) => response.data);
};
